// (() => {
//   'use strict';

//   const POPUP_ID = 'CanadaStorePopup';
//   const STORAGE_KEY = 'kabbalah_canada_popup_dismissed';
//   const CANADA_STORE_URL = 'https://store-ca.kabbalah.com/';

//   const popup = document.getElementById(POPUP_ID);

//   if (!popup) {
//     return;
//   }

//   let previouslyFocusedElement = null;

//   const openPopup = () => {
//     previouslyFocusedElement = document.activeElement;

//     popup.hidden = false;
//     popup.setAttribute('aria-hidden', 'false');

//     document.body.classList.add('canada-store-popup-open');

//     const closeButton = popup.querySelector('.canada-store-popup__close');

//     if (closeButton) {
//       closeButton.focus();
//     }
//   };

//   const closePopup = () => {
//     popup.hidden = true;
//     popup.setAttribute('aria-hidden', 'true');

//     document.body.classList.remove('canada-store-popup-open');

//     try {
//       localStorage.setItem(STORAGE_KEY, 'true');
//     } catch (error) {
//       // Ignore localStorage errors.
//     }

//     if (
//       previouslyFocusedElement &&
//       typeof previouslyFocusedElement.focus === 'function'
//     ) {
//       previouslyFocusedElement.focus();
//     }
//   };

//   const shouldShowPopup = () => {
//     try {
//       return localStorage.getItem(STORAGE_KEY) !== 'true';
//     } catch (error) {
//       return true;
//     }
//   };

//   const detectCanadianVisitor = async () => {
//     if (!shouldShowPopup()) {
//       return;
//     }

//     try {
//       const root =
//         window.Shopify && window.Shopify.routes
//           ? window.Shopify.routes.root
//           : '/';

//       const url =
//         `${root}browsing_context_suggestions.json` +
//         '?country[enabled]=true' +
//         '&country[exclude]=CA' +
//         '&language[enabled]=false';

//       const response = await fetch(url, {
//         credentials: 'same-origin',
//         headers: {
//           Accept: 'application/json'
//         }
//       });

//       if (!response.ok) {
//         return;
//       }

//       const data = await response.json();

//       const detectedCountry =
//         data?.detected_values?.country?.handle;

//       if (detectedCountry === 'CA') {
//         openPopup();
//       }
//     } catch (error) {
//       console.warn(
//         'Canada store detection failed:',
//         error
//       );
//     }
//   };

//   popup.addEventListener('click', (event) => {
//     const closeTrigger = event.target.closest(
//       '[data-canada-popup-close]'
//     );

//     if (closeTrigger) {
//       closePopup();
//     }
//   });

//   popup.addEventListener('keydown', (event) => {
//     if (event.key === 'Escape') {
//       closePopup();
//     }
//   });

//   const canadianStoreLink = popup.querySelector(
//     '[data-canada-store-link]'
//   );

//   if (canadianStoreLink) {
//     canadianStoreLink.href = CANADA_STORE_URL;
//   }

//   detectCanadianVisitor();
// })();

// (() => {
//   'use strict';

//   const POPUP_ID = 'CanadaStorePopup';
//   const CANADA_STORE_URL = 'https://store-ca.kabbalah.com/';

//   const popup = document.getElementById(POPUP_ID);

//   if (!popup) {
//     return;
//   }

//   let previouslyFocusedElement = null;

//   const openPopup = () => {
//     previouslyFocusedElement = document.activeElement;

//     popup.hidden = false;
//     popup.setAttribute('aria-hidden', 'false');

//     document.body.classList.add('canada-store-popup-open');

//     const closeButton = popup.querySelector(
//       '.canada-store-popup__close'
//     );

//     if (closeButton) {
//       closeButton.focus();
//     }
//   };

//   const closePopup = () => {
//     popup.hidden = true;
//     popup.setAttribute('aria-hidden', 'true');

//     document.body.classList.remove('canada-store-popup-open');

//     if (
//       previouslyFocusedElement &&
//       typeof previouslyFocusedElement.focus === 'function'
//     ) {
//       previouslyFocusedElement.focus();
//     }
//   };

//   const detectCanadianVisitor = async () => {
//     try {
//       const root =
//         window.Shopify && window.Shopify.routes
//           ? window.Shopify.routes.root
//           : '/';

//       const url =
//         `${root}browsing_context_suggestions.json` +
//         '?country[enabled]=true' +
//         '&country[exclude]=CA' +
//         '&language[enabled]=false';

//       const response = await fetch(url, {
//         credentials: 'same-origin',
//         headers: {
//           Accept: 'application/json'
//         }
//       });

//       if (!response.ok) {
//         return;
//       }

//       const data = await response.json();

//       console.log('Canada Popup Detection:', data);

//       const detectedCountry =
//         data?.detected_values?.country?.handle;

//       console.log('Detected Country:', detectedCountry);

//       // Show popup ONLY if the visitor is detected in Canada
//       if (detectedCountry === 'CA') {
//         openPopup();
//       }

//     } catch (error) {
//       console.warn(
//         'Canada store detection failed:',
//         error
//       );
//     }
//   };

//   // Close popup when clicking overlay, close button,
//   // or "Continue on US Store"
//   popup.addEventListener('click', (event) => {
//     const closeTrigger = event.target.closest(
//       '[data-canada-popup-close]'
//     );

//     if (closeTrigger) {
//       closePopup();
//     }
//   });

//   // Close popup with Escape key
//   popup.addEventListener('keydown', (event) => {
//     if (event.key === 'Escape') {
//       closePopup();
//     }
//   });

//   // Set Canadian store URL
//   const canadianStoreLink = popup.querySelector(
//     '[data-canada-store-link]'
//   );

//   if (canadianStoreLink) {
//     canadianStoreLink.href = CANADA_STORE_URL;
//   }

//   // Check visitor location on EVERY page load
//   detectCanadianVisitor();
// })();

(() => {
  'use strict';

  const POPUP_ID = 'CanadaStorePopup';
  const CANADA_STORE_URL = 'https://store-ca.kabbalah.com/';
  const STORAGE_KEY = 'canadaStorePopupClosed';

  const popup = document.getElementById(POPUP_ID);

  if (!popup) {
    return;
  }

  // If the user already closed it this session, don't even check location again
  if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
    return;
  }

  let previouslyFocusedElement = null;

  const openPopup = () => {
    previouslyFocusedElement = document.activeElement;

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');

    document.body.classList.add('canada-store-popup-open');

    const closeButton = popup.querySelector(
      '.canada-store-popup__close'
    );

    if (closeButton) {
      closeButton.focus();
    }
  };

  const closePopup = () => {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('canada-store-popup-open');

    // Remember that the user closed it, for the rest of this browser session
    sessionStorage.setItem(STORAGE_KEY, 'true');

    if (
      previouslyFocusedElement &&
      typeof previouslyFocusedElement.focus === 'function'
    ) {
      previouslyFocusedElement.focus();
    }
  };

  const detectCanadianVisitor = async () => {
    try {
      const root =
        window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';

      const url =
        `${root}browsing_context_suggestions.json` +
        '?country[enabled]=true' +
        '&country[exclude]=CA' +
        '&language[enabled]=false';

      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        return;
      }

      const data = await response.json();

      const detectedCountry =
        data?.detected_values?.country?.handle;

      // Show popup ONLY if the visitor is detected in Canada
      if (detectedCountry === 'CA') {
        openPopup();
      }

    } catch (error) {
      console.warn(
        'Canada store detection failed:',
        error
      );
    }
  };

  // Close popup when clicking overlay, close button,
  // or "Continue on US Store"
  popup.addEventListener('click', (event) => {
    const closeTrigger = event.target.closest(
      '[data-canada-popup-close]'
    );

    if (closeTrigger) {
      closePopup();
    }
  });

  // Close popup with Escape key
  popup.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closePopup();
    }
  });

  // Set Canadian store URL
  const canadianStoreLink = popup.querySelector(
    '[data-canada-store-link]'
  );

  if (canadianStoreLink) {
    canadianStoreLink.href = CANADA_STORE_URL;
  }

  // Check visitor location on page load, unless already dismissed this session
  detectCanadianVisitor();
})();